import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState({ name: 'NCD Admin', role: 'admin' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    API.post('/auth/login', { username: 'admin', password: 'admin123' })
      .then(r => {
        localStorage.setItem('rp_token', r.data.token);
        setUser(r.data.user);
      })
      .catch(() => {});
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, logout: () => {} }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
